import { Component, Input, OnInit, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { BodyTag } from './model/body-tag';
import { Tags } from './model/structure.object';
import { Tag } from './model/tag';
import { TypeTag } from './model/type-tag';

@Component({
  selector: 'tag-primecap',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.css']
})
export class TagComponent implements OnInit, OnChanges {
  @Input() status : string;
  type!: TypeTag | string;

  readonly tags: Tag[] = Tags;

  tag!: BodyTag;
  constructor() { }

  ngOnChanges(): void {
    this.tags.map((s: Tag) => {
      this.tag = s[this.status];
    });
  }

  ngOnInit(): void {
  }
}
